import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Session invalide');
          navigate('/login');
          return;
        }

        // Exchange session_id with backend
        const response = await fetch(`${API_URL}/auth/google/session`, {
          method: 'POST',
          headers: {
            'X-Session-ID': sessionId,
          },
        });

        if (!response.ok) {
          throw new Error('Erreur lors de l\'authentification');
        }

        const data = await response.json();
        
        // Store token and update auth context using dedicated OAuth login method
        loginWithToken(data.access_token, data.user);
        
        toast.success(`Bienvenue ${data.user.full_name || 'sur Oknî'} !`);
        
        // Redirect to dashboard
        navigate('/dashboard', { replace: true });
        
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Erreur d\'authentification');
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
        <p className="text-lg text-muted-foreground">Connexion en cours...</p>
      </div>
    </div>
  );
}
